<template>
    <div class="phone-ipt-wrap">
      <base-input-wrap title="更换手机号" :disabled="disabled" :showIptWrap="showIptWrap" @confirm="confirm" @close-ipt-wrap="close">
        <base-input  v-model="form.phone" ph="输入新手机号" :limitLen="11" @focus="errPhone = ''" @input="phoneInputHander" @blur="phoneBlur" :warning="errPhone" />
        <p v-if="errPhone" class="err">{{errPhone}}</p>
        <yz-input v-model="form.code" :phone="form.phone" @wrongPhone="errPhone = '请输入正确的11位手机号'" @focus="errCode = ''" :errCode="errCode" />
        <p v-if="errCode" class="err">{{errCode}}</p>
      </base-input-wrap>
    </div>
</template>

<script>
import baseInputWrap from './base-input-wrap'
import baseInput from './base-input'
import yzInput from './yz-input'

export default {
    data() {
        return {
          showIptWrap: false,
          form: {
            phone: '',
            code: ''
          },
          errPhone: '',
          errCode: ''
        }
    },
    created() {
      this.phoneReg = /^1[3456789]\d{9}$/;
    },
    computed: {
      disabled() {
        return !(this.form.phone.length === 11 && this.form.code && this.testPhone())
      }
    },
    methods: {
      open() {
        this.showIptWrap = true;
      },

      close() {
        this.showIptWrap = false;
        this.form.phone = ''
        this.form.code = ''
        this.errPhone = ''
        this.errCode = ''
      },

      testPhone() {
        if (this.form.phone[0] && this.form.phone[0] != 1) return false
        if (this.form.phone[1] && this.form.phone[1] < 3) return false
        if (!this.form.phone.split('').every(item => Number(item) === Number(item))) return false
        return true
      },

      phoneInputHander() {
        if (this.form.phone[0] && this.form.phone[0] != 1) return this.errPhone = '请输入正确的手机号'
        if (this.form.phone[1] && this.form.phone[1] < 3) return this.errPhone = '请输入正确的手机号'
        if (!this.form.phone.split('').every(item => Number(item) === Number(item))) return this.errPhone = '请输入正确的手机号'  // 存在非数字字符
        this.errPhone = ''
      },

      phoneBlur() {
        if (this.form.phone[0] && this.form.phone[0] != 1) return this.errPhone = '请输入正确的手机号'
        if (this.form.phone[1] && this.form.phone[1] < 3) return this.errPhone = '请输入正确的手机号'
        if (!this.form.phone.split('').every(item => Number(item) === Number(item))) return this.errPhone = '请输入正确的手机号'  // 存在非数字字符
        if (this.form.phone.length !== 11 && this.form.phone.length !== 0) {
          this.errPhone = '请输入11位手机号'
        } else {
          this.errPhone = ''
        }
      },

      confirm() {
        if (!this.testPhone()) return
        if (this.phoneLock) return;
        this.phoneLock = true
        this.$fetch.put({
          url: '/user?method=update_phone&phone=' + this.form.phone + '&code=' + this.form.code
        }).then(data => {
          if (data.success) {
            this.openMessage(1, '更换成功');
            this.close()
            this.$emit('update-user-info');
          }
        }, e => {
          this.errCode = e.error_text
          // this.openMessage(0, '更换失败')
        })
        .finally(() => setTimeout(() => this.phoneLock = false, 500));
      }
    },
    components: {
      baseInputWrap,
      baseInput,
      yzInput
    }
}
</script>

<style lang="scss" scoped>
.phone-ipt-wrap {
  position: relative;
  z-index: 100;
}

.err {
  padding: 10px 0 0 4px;
  font-size: 12px;
  color: #E51C23;
}
</style>
